import React from 'react'
import { useSelector } from 'react-redux';
import styled from 'styled-components/macro'
import { OuterWrapper, InnerWrapper } from 'utils/GlobalStyle'
import mainIcon from '../assets/mainIcon.png'

const Header = () => {
  // Shows total number of tasks in the list
  const taskList = useSelector((store) => store.tasks.items);

  // Show number of completed tasks
  const completedTasks = taskList.filter((task) => task.isCompleted);

  // Returns title and task counter
  // header1 is white div, header2 is blue div
  return (
    <>
      <OuterWrapper header1>
        <InnerWrapper>
          <AppTitle><TodoIcon src={mainIcon} alt="Todo icon" /> Daily Tasks <TodoIcon src={mainIcon} alt="Todo icon" /></AppTitle>
        </InnerWrapper>
      </OuterWrapper>
      <OuterWrapper header2>
        <InnerWrapper headerInner2>
          <p>Completed tasks:{' '}
            <span style={{ fontWeight: 600 }}>{completedTasks.length} / {taskList.length}</span>
          </p>
        </InnerWrapper>
      </OuterWrapper>
    </>

  )
}

export default Header

const AppTitle = styled.h1`
text-align: center;

@media (max-width: 350px) {
      font-size: 160%;
}

@media (max-width: 250px) {
  font-size: 130%;
}
`;

const TodoIcon = styled.img`
max-height: 10%;
max-width: 20%;
margin-bottom: -5%;
`;

